module.exports = __webpack_public_path__ + "img/titlelogo.a2f09785.png";